// extracted by mini-css-extract-plugin
export var iframe = "iframe_loader-module--iframe--49237";
export var spinner = "iframe_loader-module--spinner--243ab";
export var wrapper = "iframe_loader-module--wrapper--95427";